import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
// ============================================
// top MV
// ============================================

function sliderHero() {
	const hero01 = document.querySelectorAll('.js-slider-hero');
	if (hero01.length > 0) {
		const swiper = new Swiper('.js-slider-hero', {
			speed: 400,
			slidesPerView: 1.6,
			spaceBetween: 24,
			loop: true,
			navigation: {
				nextEl: '.js-slider__next',
				prevEl: '.js-slider__prev',
			},
			pagination: {
				el: '.js-slider__pagination',
				clickable: true,
			},
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
			breakpoints: {
				768: {
					slidesPerView: 2.1,
				},
				1024: {
					slidesPerView: 1.7,
				},
				1328: {
					slidesPerView: 1.13,
				},
			},
		});
	}
}

// ============================================
// top article
// ============================================

function sliderArticle() {
	const article01 = document.querySelectorAll('.js-slider-article');
	if (article01.length > 0) {
		const swiper = new Swiper('.js-slider-article', {
			speed: 400,
			slidesPerView: 1.5,
			spaceBetween: 24,
			loop: true,
			navigation: {
				nextEl: '.js-slider__next',
				prevEl: '.js-slider__prev',
			},
			pagination: {
				el: '.js-slider__pagination',
				clickable: true,
			},
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
			breakpoints: {
				768: {
					slidesPerView: 2.1,
				},
				1024: {
					slidesPerView: 2.5,
					spaceBetween: 40,
				},
				1328: {
					slidesPerView: 3.7,
					spaceBetween: 40,
				},
			},
		});
	}
}

// ============================================
// export
// ============================================
export { sliderHero , sliderArticle };
